require('./bootstrap');

window.noUiSlider = require('nouislider'); // slider
window.Colcade = require('colcade'); // masonry

import lightGallery from 'lightgallery'; // lightbox core
window.lightGallery = lightGallery; // lightbox core

import lgThumbnail from 'lightgallery/plugins/thumbnail'; // lightbox lgThumbnail plugin
window.lgThumbnail = lgThumbnail; // lightbox lgThumbnail plugin

import lgZoom from 'lightgallery/plugins/zoom'; // lightbox lgZoom plugin
window.lgZoom = lgZoom; // lightbox lgZoom plugin

import lgShare from 'lightgallery/plugins/share'; // lightbox lgShare plugin
window.lgShare = lgShare; // lightbox lgShare plugin

// https://www.npmjs.com/package/smoothscroll-polyfill
// The Scroll Behavior specification has been introduced as an extension of the Window
// interface to allow for the developer to opt in to native smooth scrolling. To date this has only been
// The script will detect if the spec is natively supported and take action only when necessary
// In this app we use this for car carousels
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// tagging events to push to dataLayer
require('./tagging_events');